/* eslint-disable */
import axiosIns, { axiosDefault} from '@/libs/axios'
import { requestApi } from '@/libs/secret'

export default {
  namespaced: true,
  state: {
    dataReport: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'campaign_id', label: 'Campaign ID', sortable: true },
        { key: 'campaign_name', label: 'Campaign Name', sortable: true },
        // { key: 'creator', label: 'Creator', sortable: true },
        { key: 'company_name', label: 'Company Name', sortable: true },
        // { key: 'created_at', label: 'Created', sortable: true },
        // { key: 'start_date', label: 'Start Date', sortable: true },
        // { key: 'end_date', label: 'End Date', sortable: true },
        { key: 'channel_name', label: 'Channel', sortable: true },
        { key: 'method_name', label: 'Buy Method', sortable: true },
        { key: 'sent', label: 'Sent', sortable: true, thClass: 'd-none', tdClass: 'd-none'},
        { key: 'impression', label: 'Impressions', sortable: true },
        { key: 'click', label: 'Clicks' },
        { key: 'ctr', label: 'CTR', sortable: true },
        { key: 'cvr', label: 'CVR', sortable: true },
        { key: 'startDate', label: 'Start Date', sortable: true },
        { key: 'endDate', label: 'End Date', sortable: true },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },
    campaignIdList: [],
    campaign: [],
    startDate: '',
    endDate: '',
    company: [],
    channel: [],
    method: [],
    companyFilter: [],
    channelFilter: [],
    methodFilter: [],
    campaignFilter: [],
    startDateFilter: '',
    endDateFilter: '',
    totalCampaign: {},
  },
  getters: {
    getReportItem: state => state.dataReport.items,
    getReportField: state => state.dataReport.fields,
    getReportStatus: state => state.dataReport.status,
    getCurrentPage: state => state.dataReport.items.current_page,
    getSortBy: state => state.dataReport.sortBy,
    getSortDesc: state => state.dataReport.sortDesc,
    getSearch: state => state.dataReport.search,
    getCampaignIdList: state => state.campaignIdList,
    getCampaign: state => state.campaign,
    getStartDate: state => state.startDate,
    getEndDate: state => state.endDate,
    getCompany: state => state.company,
    getChannel: state => state.channel,
    getMethod: state => state.method,
    getCompanyFilter: state => state.companyFilter,
    getChannelFilter: state => state.channelFilter,
    getMethodFilter: state => state.methodFilter,
    getCampaignFilter: state => state.campaignFilter,
    getStartDateFilter: state => state.startDateFilter,
    getEndDateFilter: state => state.endDateFilter,
    getTotalCampaign: state => state.totalCampaign,
  },
  mutations: {
    SET_DATA_REPORT_ITEM: (state, value) => (value ? (state.dataReport.items = value) : (state.dataReport.items = [])),
    SET_ITEM_DATA: (state, value) => (value ? (state.dataReport.items.data = value) : (state.dataReport.items.data = [])),
    SET_LIST_CURRENT_PAGE: (state, value) => (value ? (state.dataReport.items.current_page = value) : (state.dataReport.items.current_page = 1)),
    SET_LIST_SORT_BY: (state, value) => (value ? (state.dataReport.sortBy = value) : (state.dataReport.sortBy = '')),
    SET_LIST_SORT_DESC: (state, value) => (value ? (state.dataReport.sortDesc = value) : (state.dataReport.sortDesc = false)),
    SET_LIST_SEARCH: (state, value) => (value ? (state.dataReport.search = value) : (state.dataReport.search = '')),
    SET_CAMPAIGN_ID_LIST: (state, value) => (value ? (state.campaignIdList = value) : (state.campaignIdList = [])),
    SET_CAMPAIGN: (state, value) => (value ? (state.campaign = value) : (state.campaign = [])),
    SET_START_DATE: (state, value) => (value ? (state.startDate = value) : (state.startDate = '')),
    SET_END_DATE: (state, value) => (value ? (state.endDate = value) : (state.endDate = '')),
    SET_CAMPAIGN_FILTER: (state, value) => (value ? (state.campaignFilter = value) : (state.campaignFilter = [])),
    SET_COMPANY: (state, value) => (value ? (state.company = value) : (state.company = [])),
    SET_CHANNEL: (state, value) => (value ? (state.channel = value) : (state.channel = [])),
    SET_METHOD: (state, value) => (value ? (state.method = value) : (state.method = [])),
    SET_COMPANY_FILTER: (state, value) => (value ? (state.companyFilter = value) : (state.companyFilter = [])),
    SET_CHANNEL_FILTER: (state, value) => (value ? (state.channelFilter = value) : (state.channelFilter = [])),
    SET_METHOD_FILTER: (state, value) => (value ? (state.methodFilter = value) : (state.methodFilter = [])),
    SET_START_DATE_FILTER: (state, value) => (value ? (state.startDateFilter = value) : (state.startDateFilter = '')),
    SET_END_DATE_FILTER: (state, value) => (value ? (state.endDateFilter = value) : (state.endDateFilter = '')),
    SET_TOTAL_CAMPAIGN: (state, value) => (value ? (state.totalCampaign = value) : (state.totalCampaign = {})),

  },
  actions: {
    getReport({ commit, getters, rootState }) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const dataSend = {
        campaign_id: getters.getCampaign,
        start_date: getters.getStartDate,
        end_date: getters.getEndDate,
        channel: getters.getChannel,
        method: getters.getMethod,
        company: getters.getCompany,
        search: getters.getSearch,
      }
      commit('SET_ITEM_DATA')
      commit('SET_CAMPAIGN_FILTER', getters.getCampaign)
      commit('SET_COMPANY_FILTER', getters.getCompany)
      commit('SET_CHANNEL_FILTER', getters.getChannel)
      commit('SET_METHOD_FILTER', getters.getMethod)
      commit('SET_START_DATE_FILTER', getters.getStartDate)
      commit('SET_END_DATE_FILTER', getters.getEndDate)
      return new Promise((resolve, reject) => {
        const paramQuery = `page=${getters.getCurrentPage}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}`
        // console.log(paramQuery, dataSend)
        const queryParam = requestApi(paramQuery)
        axiosIns.post(`/campaign/report?req=${queryParam.req}`, dataSend, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_DATA_REPORT_ITEM', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    dataCampaignList({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/campaign/activeCampaign', { headers })
          .then(response => {
            const newData = response.data.data
            commit('SET_CAMPAIGN_ID_LIST', newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    dataTotalCampaign({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('/report/campaign', { headers })
          .then(response => {
            const newData = response.data.data
            commit('SET_TOTAL_CAMPAIGN', newData)
            resolve(newData)
          }).catch(error => {
            reject(error)
          })
      })
    },
    downloadTable({ getters, rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const user = rootState.auth.userData.data.id
      const dataSend = {
        // campaign_id: `[${getters.getCampaignFilter.toString()}]`,
        start_date: getters.getStartDateFilter,
        end_date: getters.getEndDateFilter,
        channel: getters.getChannelFilter,
        method: getters.getMethodFilter,
        company: `[${getters.getCompanyFilter.toString()}]`,
        search: getters.getSearch,
        filter: getters.getSearch,
        sortBy: getters.getSortBy,
        sortdirt: desc,
        user: user,
        type: payload,
      }
      return new Promise((resolve, reject) => {
        // const queryParam = requestApi(`user=${user}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}`)
        axiosDefault.post(`/campaign/reportDownload`, dataSend, { headers, responseType: 'blob' }
        // { responseType: 'arraybuffer'}
        )
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
